import { render, staticRenderFns } from "./foto-met-tekst.vue?vue&type=template&id=b66e4096&scoped=true"
import script from "./foto-met-tekst.vue?vue&type=script&lang=js"
export * from "./foto-met-tekst.vue?vue&type=script&lang=js"
import style0 from "./foto-met-tekst.vue?vue&type=style&index=0&id=b66e4096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66e4096",
  null
  
)

export default component.exports